export const APP_NAME = "Hanaro InVo";
export const APP_TAGLINE = "AI invoice scan + matching";

/** Logo colours — Hanaro green, tuned for small sizes (sidebar + favicon). */
export const BRAND_LOGO = {
  bg: "#15803d",
  ink: "#ffffff",
} as const;
